import type { TaskFilterMenuSectionConfig } from './TaskFilterMenu'

type ActiveFilterCountOptions = {
  includeRadio?: boolean
}

export const getActiveFilterCount = (
  sections: TaskFilterMenuSectionConfig[],
  { includeRadio = false }: ActiveFilterCountOptions = {},
): number =>
  sections.reduce((count, section) => {
    if (section.type === 'text') {
      const defaultValue = section.defaultValue ?? ''
      return count + Number(section.value.trim() !== defaultValue.trim())
    }

    if (section.type === 'radio') {
      const defaultValue = section.defaultValue ?? null
      return count + Number(includeRadio && section.value !== defaultValue)
    }

    const defaultIds = section.defaultValue ?? []
    const addedIds = section.value.filter((id) => !defaultIds.includes(id))
    const removedIds = defaultIds.filter((id) => !section.value.includes(id))
    return count + addedIds.length + removedIds.length
  }, 0)
